"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidRect = void 0;
var isValidRect = function (rect) {
    return rect.width > 0 && rect.height > 0;
};
exports.isValidRect = isValidRect;
